import { useIsFeatureFlagEnabled } from "@circle-react/hooks/UseCommunitySetting";
import type { Chat } from "@circle-react/types/CommunityInbox/Chat";

export const AVATARS_V2_UI_FEATURE_FLAG = "avatars_v2_ui_enabled";

// Reversible rollout control for every Avatars v2 UI change until release; the
// runtime says whether the Avatars engine is the one answering.
export const useIsAvatarsV2Ui = (chat: Chat | null | undefined) => {
  const isAvatarsV2UiEnabled = useIsFeatureFlagEnabled(
    AVATARS_V2_UI_FEATURE_FLAG,
  );
  return isAvatarsV2UiEnabled && chat?.runtime === "ruby_llm_v1";
};
